// page init
jQuery(function() {
	initQty();
	initTabs();
	initSlickCarousel();
});

function initQty() {
	jQuery(".counter__increment, .counter__decrement").click(function(e) {
		var $this = $(this);
		var $counter__input = jQuery(this).parent().find(".counter__input");
		var $currentVal = parseInt(jQuery(this).parent().find(".counter__input").val());

		if ($currentVal != NaN && $this.hasClass('counter__increment')) {
			$counter__input.val($currentVal + 1);
		} else if ($currentVal != NaN && $this.hasClass('counter__decrement')) {
			if ($currentVal >= 1) {
				$counter__input.val($currentVal - 1);
			}
		}
	});
}

function initTabs() {
	jQuery('.tabs .tab-links a').on('click', function(e) {
		var currentAttrValue = jQuery(this).attr('href');

		// Show/Hide Tabs
		jQuery('.tabs ' + currentAttrValue).show().siblings().hide();

		// Change/remove current tab to active
		jQuery(this).parent('li').addClass('active').siblings().removeClass('active');

		e.preventDefault();
	});
}

